import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/user/sales-reps";
const apiInviteEndpoint = API_BASE_URL_ENV() + "/admin/user/sales-rep/invite"
const apiToggle = API_BASE_URL_ENV() + "/admin/user/toggle-activation/SalesRep"
const apiAssignArea = API_BASE_URL_ENV() + "/admin/user/sales-rep/area/assign"
const apiAssignCompound = API_BASE_URL_ENV() + "/admin/user/sales-rep/compound/assign"
const apiDropDownEndpoint = API_BASE_URL_ENV() + "/admin/user/dropdown/SalesRep?status=1";
const exportApi = API_BASE_URL_ENV() + "/admin/user/sales-reps?export=1"

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }

    inviteSalesRep = (data) => {
        return http.post(apiInviteEndpoint, data)
    }

    toggleStatus(id) {
        return http.get(`${apiToggle}/${id}`);
    }
    assignArea = (data) => {
        return http.post(apiAssignArea, data)

    }
    assignCompound = (data) => {
        return http.post(apiAssignCompound, data)

    }
    getDropDown = (status) => {
        if (status = "all") {
            return http.get(apiDropDownEndpoint)
        } else {
            return http.get(`${apiDropDownEndpoint}?status=1`)
        }
    }

    getExportUrl = (searchWord, filterData, active) => {
        const obj = JSON.parse(localStorage.getItem("auth"))
        let url = `${exportApi}&token=${obj.access_token}`;
        if (active != 'all') url = url + `&status=${active === "active" ? 1 : 0}`;
        if (searchWord.trim().length) url = url + `&keyword=${searchWord}`;
        if (filterData ?.area_ids&&filterData ?.area_ids ?.length !== 0) url = url + `&area_ids=${filterData ?.area_ids ?.map(area => area.value).join()}`;
        if (filterData ?.compound_ids && filterData ?.compound_ids ?.length !== 0) url = url + `&compound_ids=${filterData ?.compound_ids ?.map(compound => compound.value).join()}`;
        return url
    }

    deleteSalesRep = (id, allData)=>{
        let url = `${apiEndpoint+'/'+id}`
        return http.delete(url, {
            data: allData
        })
    }
}
